var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.312 12.164h2.805c.248 0 .457.088.627.265.17.178.256.395.256.653a.906.906 0 0 1-.256.652.837.837 0 0 1-.627.266h-4.572l1.767-1.836zM2.55 14a.872.872 0 0 1-.632-.271l-1.4-1.454A1.835 1.835 0 0 1 0 10.973 1.85 1.85 0 0 1 .504 9.65l8.5-9.1A1.63 1.63 0 0 1 10.252 0c.49.002.906.18 1.247.534l3.766 3.915c.34.354.511.789.511 1.304 0 .516-.17.95-.511 1.305L8.98 13.724a.901.901 0 0 1-.292.206.846.846 0 0 1-.34.07H2.55zm5.42-1.836 6.055-6.426-3.751-3.9-8.53 9.102 1.178 1.224h5.049z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFormat);
export default __webpack_public_path__ + "static/media/clear-format.2f9e6bef8f4f28f79ffc24b0842e121a.svg";
export { ForwardRef as ReactComponent };